import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    promoteUser: boolean,
}

interface Variables {
    promoteUserId: string,
}

export const PROMOTE_USER: TypedDocumentNode<Result, Variables> = gql`
    mutation PromoteUser($promoteUserId: Int!){
        promoteUser(id: $promoteUserId)
    }       
`
